<!-- TEMPLATE -->
<template>
    <dean-alert-dialog
            class="notification"
            :data="storedAlertNotification.type"
            v-if="storedAlertNotification.show && isModal === alertSendToModal"
            @close="closeNotification"
            :theme="storedAlertNotification.type.theme">
    </dean-alert-dialog>
</template>

<!-- SCRIPT -->
<script lang="ts">
    // VUE
    import Vue from 'vue'
    import {Component, Prop} from 'vue-property-decorator';

    import {
        // COMPONENTS
        deanAlertDialog,
        messageIcon
    } from '@deanone/dean-components'

    // COMPONENTS
    @Component({
        components: {
            deanAlertDialog,
            messageIcon
        }
    })


// EXPORT
    export default class alertNotification extends Vue {
        public messageIcon: object = messageIcon;
        @Prop({default: false}) public isModal!: boolean;
        public alertSendToModal: boolean = false;

        get storedAlertNotification() {
            this.alertSendToModal = this.$store.getters.getAlertNotification.type.modal ?
                this.$store.getters.getAlertNotification.type.modal : false;
            return this.$store.getters.getAlertNotification;
        }

        // METHODS
        public closeNotification() {
            this.$store.dispatch('setAlertNotification', { show: false });
        }

        updated() {
            const self = this;
            setTimeout(() => {
                self.$store.dispatch('setAlertNotification', { show: false });
            }, 5000);
        }
    }
</script>

<!-- STYLE -->
<style lang="scss"></style>
